import { render } from "./V-dialog-confirm.vue?vue&type=template&id=fed3570e&scoped=true"
import script from "./V-dialog-confirm.vue?vue&type=script&lang=js"
export * from "./V-dialog-confirm.vue?vue&type=script&lang=js"

import "./V-dialog-confirm.vue?vue&type=style&index=0&id=fed3570e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fed3570e"]])

export default __exports__